/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors, timings } from "../../theme";

const style = css`
    color: ${colors.info6};
    &:hover {
        color: ${colors.info5};
    }
    transition: ${timings.medium};
    font-size: 16px;
    height: 52px;
    padding: 32px;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
`;

const SecondaryCTA = props => (
    <a {...props} css={style}>
        {props.children}
    </a>
);

export default SecondaryCTA;
